<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title"> {{ 'REFERENCE.REFERENCE_LIST' | translate }} </div>
                <div class="tools">

                    <div class="form-wrapper">
                        <form class="form" [formGroup]="searchForm" autocomplete="off">
                            <div class="">
                                <input formControlName="searchReference" class="form-control serch-form" type="text"
                                    placeholder="{{ 'SEARCH' | translate }}" aria-label="Search">
                            </div>
                        </form>
                    </div>

                     <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()"
                        (click)="deleteSelected()">
                        <i class="bi bi bi-trash"></i> {{ 'DELETE_SELECTED' | translate }}
                    </button>

                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()">
                        <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                    </button>

                    <!-- <div class="orgs-list" *ngIf="permissionAccess.check('REFERENCES_ORGANIZATIONS')">

                        <div class="dropleft">
                            <button class="btn btn-primary dropdown-toggle btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ 'REFERENCE.SELECT_ORGANIZATION' | translate }}
                            </button>

                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">

                                <button class="btn btn-primary btn-sm" type="button" (click)="resetSearch()"> {{ 'REFERENCE.LIST_OF_DEFAULT_DIRECTORIES' | translate }}</button>

                                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                                    <input formControlName="search" class="form-control" type="text" placeholder="{{ 'SEARCH' | translate }}" aria-label="Search">

                                    <div class="data-not-found" *ngIf="organizations.length == 0">
                                        <span>{{ 'NOTHING_FOUND' | translate }}</span>
                                    </div>
                          
                                  </form>

                                <div>
                                    <button class="dropdown-item btn btn-outline btn-sm" type="button" 
                                    *ngFor="let org of organizations" (click)="getList(org.id)">
                                        {{org.name}}
                                    </button> 
                                </div>
                            </div>
                          </div>
                    </div> -->
                </div>
            </div>

            <div class="card-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_reference_all"
                                        id="select_reference_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_reference_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="name"> {{ 'DENOMINATION' | translate }} </th>
                            <th scope="col" class="action"></th>
                        </tr>
                    </thead>

                    <tbody *ngIf="references && references.length > 0">
                        <tr *ngFor="let reference of references; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_reference_{{ i }}"
                                        id="select_reference_{{ i }}" [checked]="reference.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_reference_{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name">{{reference.name}}</td>
                            <td class="action">
                                <div class="action-btn">
                                    <!-- btn unlock role -->
                                    <button type="button" class="btn btn-none" (click)="onEdit(reference.id)" placement="left" tooltipClass="clue-name" ngbTooltip="{{ 'EDIT' | translate }}">
                                        <svg-icon class="" src="/assets/images/icons/edit.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                    </button>
    
                                    <!-- btn block role -->
                                    <button type="button" class="btn btn-none" (click)="onDelete(reference.id)" placement="left"  tooltipClass="clue-name" ngbTooltip="{{ 'DELETE' | translate }}">
                                        <svg-icon class="" src="/assets/images/icons/delete.svg" [stretch]="true"[svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                    </button>
    
                                    <!-- <section class="action-btn_list">
        
                                        <ng-template class="btn-list" #popContent>
    
                                            <div class="btn-list_item"
                                                (click)="onEdit(role.urole.id)">
                                                <span>{{ 'Редактировать' | translate }}</span>
                                            </div>
    
                                            <div class="list-item_delete"
                                                (click)="deleteOneRole(role.urole.id)">
                                                <span>{{ 'Удалить' | translate }}</span>
                                            </div>
    
                                        </ng-template>
    
                                        <button type="button" placement="left" [ngbPopover]="popContent"
                                            [autoClose]="true" triggers="manual" #p="ngbPopover"
                                            class="btn btn-none action-btn_active btn-sm"
                                            popoverClass="my-custom-class"
                                            (click)="openWindowWithButton(p)"
                                            ngbTooltip="Действия">
                                            <svg-icon class="" src="/assets/images/icons/actions-more.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':20, 'height.px':20}"><i class="bi bi-three-dots-vertical"></i> </svg-icon>
                                        </button>
                                    </section> -->
    
                                </div>
                                    
                            </td>
                            <!-- <td class="action">

                                edit
                                <button type="button" class="btn btn-light" (click)="onEdit(reference.id)"
                                    placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button>

                                delete
                                <button type="button" class="btn btn-light" (click)="onDelete(reference.id)"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td> -->
                        </tr>
                    </tbody>

                    <tbody *ngIf="!references || references.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="3">
                                <div> {{ 'LOADING' | translate }} </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="3">
                                <div> {{ 'DATA_NOT_FOUND' | translate }} </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>
    </div>
</div>